// @ts-nocheck
import styled from 'styled-components';
import colors from '../../../styles/colors';

const SpaceActionButtonsAndAvatarContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

const SpaceActionButton = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 33.33%;
    gap: 10px;
`;

const SpaceAvatar = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 33.33%;
`;

const ButtonDivAction = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 90%;
    padding: 5px 5px;;
    border-radius: 5px;
    border: 2px solid black;
    color: white;
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;

    &.albo-doro {
        background-color: ${props => props.$isAlboDoroOpen ? colors.bgColorBordeaux : 'rgba(255,255,255,0.06)'};
    }

    &.info {
        background-color: ${props => props.$isInfoPageOpen ? colors.bgColorBordeaux : 'rgba(255,255,255,0.06)'};
    }

    &.prime {
        background-color: ${props => props.$isPrimePageOpen ? colors.bgColorBordeaux : 'rgba(255,255,255,0.06)'};
    }

    &.archivio {
        background-color: ${props => props.$isArchivioPageOpen ? colors.bgColorBordeaux : 'rgba(255,255,255,0.06)'};
    }

    &.nemici-amici {
        background-color: ${props => props.$isNemiciAmiciPageOpen ? colors.bgColorBordeaux : 'rgba(255,255,255,0.06)'};
    }

    &.top-match {
        background-color: ${props => props.$isTopMatchPageOpen ? colors.bgColorBordeaux : 'rgba(255,255,255,0.06)'};
    }
`;

const BoxAvatarWrestler = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    & .avatar-wrestler {
        width: 90px;
        height: 90px;
        border-radius: 5px;
        object-fit: cover;
        object-position: top;
        border: 1px solid ${colors.bgColorBlack2};
    }
`;

const ButtonForumUrlMobile = styled.button`
    background-color: ${colors.bgColorBlack2};
    color: white;
    border: 1px solid white;
    border-radius: 5px;
    padding: 2px 7px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 9px;
    margin-top: 2px;

    &:hover {
        background-color: white;
        color: ${colors.bgColorBlack2};
    }
`;

function SpaceActionsButtonsAndAvatarRender({
    wrestlerData,
    isAlboDoroOpen,
    isInfoPageOpen,
    isPrimePageOpen,
    isArchivioPageOpen,
    isNemiciAmiciPageOpen,
    isTopMatchPageOpen,
    handleClickAlboDoroOpen,
    handleClickInfoPageOpen,
    handleClickPrimePageOpen,
    handleClickArchivioPageOpen,
    handleClickNemiciAmiciPageOpen,
    handleClickTopMatchPageOpen
}) {
    function navigateGoToForumUrl(forumUrl) {
        // navigazione presso pagina esterna (si apre nuova scheda)
        window.open(forumUrl, '_blank');
    }

    if (!wrestlerData) {
        return null;
    }

    return (
        <SpaceActionButtonsAndAvatarContainer className='space-action-buttons-and-avatar'>
            <SpaceActionButton 
             className='space-action-button left'
            >
                <ButtonDivAction 
                    className='action-button albo-doro'
                    $isAlboDoroOpen={isAlboDoroOpen}
                    onClick={handleClickAlboDoroOpen}
                >
                    Albo d'oro
                </ButtonDivAction>
                <ButtonDivAction 
                    className='action-button top-match'
                    $isTopMatchPageOpen={isTopMatchPageOpen}
                    onClick={handleClickTopMatchPageOpen}
                >
                    Top Match
                </ButtonDivAction>

                <ButtonDivAction 
                    className='action-button nemici-amici'
                    $isNemiciAmiciPageOpen={isNemiciAmiciPageOpen}
                    onClick={handleClickNemiciAmiciPageOpen}
                >
                    Nemici Amici
                </ButtonDivAction>
            </SpaceActionButton>

            <SpaceAvatar className='space-avatar'>
                <BoxAvatarWrestler className='box-avatar-wrestler'>
                    <img 
                        src={process.env.REACT_APP_STORAGE_URL + wrestlerData.avatar_path} 
                        alt={wrestlerData.name} 
                        className='avatar-wrestler'
                    />
                </BoxAvatarWrestler>
                {wrestlerData.forum_url && (
                    <ButtonForumUrlMobile className='button-forum-url-mobile' onClick={() => navigateGoToForumUrl(wrestlerData.forum_url)}>Profilo Forum</ButtonForumUrlMobile  >
                )}
            </SpaceAvatar>

            <SpaceActionButton className='space-action-button right'
             $isInfoPageOpen={isInfoPageOpen}
             $isPrimePageOpen={isPrimePageOpen}
             $isArchivioPageOpen={isArchivioPageOpen}
             $isNemiciAmiciPageOpen={isNemiciAmiciPageOpen}
             $isTopMatchPageOpen={isTopMatchPageOpen}
             $isAlboDoroOpen={isAlboDoroOpen}
            >
                <ButtonDivAction 
                    className='action-button info'
                    $isInfoPageOpen={isInfoPageOpen}
                    onClick={handleClickInfoPageOpen}
                >
                    Info
                </ButtonDivAction>
                <ButtonDivAction 
                    className='action-button prime'
                    $isPrimePageOpen={isPrimePageOpen}
                    onClick={handleClickPrimePageOpen}
                >
                    Prime
                </ButtonDivAction>

                <ButtonDivAction 
                    className='action-button archivio'
                    $isArchivioPageOpen={isArchivioPageOpen}
                    onClick={handleClickArchivioPageOpen}
                >
                    Archivio
                </ButtonDivAction>
            </SpaceActionButton>
        </SpaceActionButtonsAndAvatarContainer> 
    )
}

export default SpaceActionsButtonsAndAvatarRender;